/**
 * @generated SignedSource<<8bd85d8b79e2da57a92d99b61dc58d81>>
 * @relayHash ec9cefb31def2a253159e9c6b98dd972
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID adcba64c6f491270352cf7677a7db4627e1a076a3d48294e614af4570b929eff

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PlanListQuery$variables = {
  cloudId: string;
  currentURLPath?: AGG$URL | null | undefined;
};
export type PlanListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PlansList">;
};
export type PlanListQuery = {
  response: PlanListQuery$data;
  variables: PlanListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentURLPath"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "planId"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "isReadOnly"
          },
          {
            "kind": "ScalarField",
            "name": "planStatus"
          },
          {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isFavourite"
              },
              (v2/*: any*/)
            ]
          },
          {
            "concreteType": "JiraScenario",
            "kind": "LinkedField",
            "name": "scenario",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "scenarioId"
              },
              (v2/*: any*/)
            ]
          }
        ],
        "type": "JiraPlan"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v2/*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
      }
    ]
  }
],
v4 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PlanListQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "currentURLPath",
            "variableName": "currentURLPath"
          }
        ],
        "kind": "FragmentSpread",
        "name": "PlansList"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlanListQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "favouritePlans",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "sort": {
                    "order": "DESC"
                  },
                  "type": "PLAN"
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 15
              }
            ],
            "concreteType": "JiraFavouriteConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraFavouriteEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v3/*: any*/)
              },
              (v4/*: any*/)
            ]
          },
          {
            "alias": "recentPlans",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "currentURL",
                "variableName": "currentURLPath"
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              },
              {
                "kind": "Literal",
                "name": "types",
                "value": [
                  "PLAN"
                ]
              }
            ],
            "concreteType": "JiraSearchableEntityConnection",
            "kind": "LinkedField",
            "name": "recentItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSearchableEntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v3/*: any*/)
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "adcba64c6f491270352cf7677a7db4627e1a076a3d48294e614af4570b929eff",
    "metadata": {},
    "name": "PlanListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c8de83b9c22a2a08040b53650c90d657";

export default node;
